<template>
  <div v-if="current">

    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block v-if="$auth.check('INFRA_DIO_WRITE')">+</v-btn>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>POP</th>
          <th>Código</th>
          <th>Portas</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.nome }}</td>
          <td>{{ item.pop }}</td>
          <td>{{ item.codigo }}</td>
          <td>{{ item.portas }}</td>
          <td>
            <v-btn small color="primary" @click="portas(item.id)">portas</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/dio", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    portas: function(id) {
      router.push({ path: `/dio_porta/dio/${id}` });
    },
    register: function() {
      router.push({ path: "/dio/0" });
    }
  }
};
</script>